import {AbstractContactVO} from "@well/domain";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {AbstractResourceService} from "@irian-ro/abstract-resource";

@Injectable()
export abstract class NotifiableContactResourceService extends AbstractResourceService<any, any, any, any>{

  abstract getNotifiableContactsForEntityUuid(entityUuid: string): Observable<AbstractContactVO[]>;

  abstract getAvailableNotifiableContactsForEntityUuid(entityUuid: string): Observable<AbstractContactVO[]>;

  abstract updateNotifiableContactsForEntityUuid(entityUuid: string, contactUuids: string[]): Observable<AbstractContactVO[]>;
}
